import * as styles from './WorkoutHeader.css';
import {
  faChevronDown,
  faChevronUp,
  faStopwatch,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { PropsWithChildren, useState } from 'react';
import { useAutoAnimateSafe } from '@design-system/utils';

export const HeaderContent = ({
  title,
  dotContent,
}: {
  title: string;
  dotContent?: string;
}) => {
  return (
    <Row alignCenter>
      <Typography variant="title" size="large">
        {title}
      </Typography>
      {dotContent ? (
        <>
          <div className={styles.dot}>·</div>
          <FontAwesomeIcon icon={faStopwatch} color="white" />
          <Typography variant="body" size="small" uppercase>
            {dotContent}
          </Typography>
        </>
      ) : null}
    </Row>
  );
};

export const CollapsibleWorkoutHeader = ({
  Header,
  Action,
  variant,
  defaultOpen = false,
  className,
  id,
  children,
}: PropsWithChildren<{
  Header: JSX.Element;
  Action?: JSX.Element;
  variant?: 'primary' | 'secondary';
  defaultOpen?: boolean;
  className?: string;
  id?: string;
}>) => {
  const [ref] = useAutoAnimateSafe({ duration: 200 });
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div
      ref={ref}
      className={className}
      id={id}
      style={{ overflow: isOpen ? 'visible' : 'hidden' }}
    >
      <Row
        className={
          variant === 'secondary' ? styles.secondaryHeader : styles.header
        }
        style={{ borderRadius: isOpen ? '9px 9px 0 0' : '9px' }}
        onClick={toggleOpen}
        gap="xl"
        spreadEvenly
      >
        <Col style={{ flexGrow: 1 }}>
          <Row alignCenter>
            <FontAwesomeIcon icon={!isOpen ? faChevronUp : faChevronDown} />
            {Header}
          </Row>
        </Col>

        {Action && <Col style={{ flexGrow: 0 }}>{Action}</Col>}
      </Row>
      {isOpen && children}
    </div>
  );
};
